<template>
  <ul :class="$style.root">
    <template
      v-for="(entry, index) in data?.data"
      :key="entry?.id"
    >
      <li>
        <shared-publication-thumbnail-component
          :entry="entry"
        />
      </li>
    </template>
  </ul>
</template>

<script lang="ts" setup>
const route = useRoute()

const page = ref(1)

const filterId = computed(() => {
  return route.query.biennialEntryId
})

const filterIdSecondary = computed(() => {
  return route.query.categoryId
})

watch([filterId, filterIdSecondary], () => {
  page.value = 1
})

const { data, error, execute, status } = await useAsyncData(() => {
  return $fetch('/api/strapi-rest', { query: { path: queryPublicationEntriesThumbnail(getPageQuery({page: page.value, filterId: filterId.value, filterIdSecondary: filterIdSecondary.value})) } })
}, { watch: [page, filterId, filterIdSecondary] })

const canLoadMore = computed(() => {
  return data.value?.meta?.pagination?.page < data.value?.meta?.pagination?.pageCount
})

watch(data, (newValue, oldValue) => {
  if (oldValue && newValue && newValue.meta?.pagination?.page === (oldValue.meta?.pagination?.page + 1) ) {
    data.value.data = oldValue.data.concat(newValue.data)
    if (canLoadMore.value) {
      page.value++
    }
  } else if ( newValue ) {
    data.value = newValue
  }
})

setTimeout(() => {
  if (canLoadMore.value) {
    page.value++
  }
}, 10)
</script>

<style module lang="scss">
.root {
  composes: reset-list container-flex container-large from global;
}

.groupKey {
  width: 100%;
  text-align: center;

  margin-top: var(--unit--vertical);
  margin-bottom: var(--unit--vertical);
}
</style>
